import React from "react";
import { useNavigate } from "react-router-dom";
import ModalNew from "./Modal";
import { PopupContent, PopupHeader } from "./common";

function AuthModal({ onClose }) {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    // We close the modal before navigating
    onClose();
    navigate(path);
  };

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "440px" }}>
      <PopupHeader
        title="Join the Conversation"
        setOpenState={onClose}
        icon={`${process.env.PUBLIC_URL}/images/icons/message_blue.svg`}
        variant="compact"
      />
      <PopupContent>
        <div
          className="auth-modal-content"
          style={{ textAlign: "center", padding: "10px 0" }}
        >
          <p
            style={{
              color: "#666B6F",
              marginBottom: "24px",
              lineHeight: "1.5",
            }}
          >
            We love the insight! Please sign in or create a Plaintr account to
            post your comment and engage with the community.
          </p>

          <div
            className="auth-modal-actions"
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <button
              type="button"
              className="cta-button primary"
              onClick={() => handleNavigation("/sign-in")}
              style={{ width: "100%" }}
            >
              Sign In
            </button>
            <button
              type="button"
              className="cta-button secondary"
              onClick={() => handleNavigation("/sign-up")}
              style={{ width: "100%" }}
            >
              Create an Account
            </button>
          </div>

          <button
            type="button"
            onClick={onClose}
            style={{
              marginTop: "16px",
              background: "none",
              border: "none",
              color: "#999",
              cursor: "pointer",
              fontSize: "13px",
            }}
          >
            Maybe later
          </button>
        </div>
      </PopupContent>
    </ModalNew>
  );
}

export default AuthModal;
